/**
 * The customer support contact (WhatsApp). 330 moved it here from `AccountPage.tsx`, because the profile's
 * "Ask Carii to change it" (the campus) opens the same contact — one number, one place.
 */
export const SUPPORT_WHATSAPP_URL = 'https://wa.me/60185798832';
